export const ADD_NOTICE_REQUEST = 'ADD_NOTICE_REQUEST'
export const ADD_NOTICE_SUCCESS = 'ADD_NOTICE_SUCCESS'
export const ADD_NOTICE_FALIURE = 'ADD_NOTICE_FALIURE'
